// 5.24.0 FAQ — citation "bubble" cards under an answer, and the conflict box.
// A document card shows title/filename, doc date, page, the verbatim quote, and an Outdated badge when a newer
// document exists for the company; click opens the source at that page (onOpen). Fact cards say "Agency fact".
import React from 'react';

export const fmtDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return y && m && d ? `${m}/${d}/${y}` : String(iso);
};

export function CitationCard({ c, darkMode, onOpen }) {
  const isDoc = c.kind === 'document';
  const bg = darkMode ? '#23272f' : '#f4f7fb';
  const border = darkMode ? '#3a4150' : '#d6e0ee';
  const sub = darkMode ? '#9aa4b2' : '#5b6675';
  return (
    <button type="button" data-testid="faq-citation" onClick={() => isDoc && onOpen && onOpen(c)}
      title={isDoc ? 'Open the source at this page' : 'Agency fact'}
      style={{ textAlign: 'left', background: bg, border: `1px solid ${border}`, borderRadius: 14, padding: '8px 12px',
        cursor: isDoc ? 'pointer' : 'default', maxWidth: 340, minWidth: 200, color: 'inherit', font: 'inherit',
        display: 'flex', flexDirection: 'column', gap: 4 }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', fontSize: 12, fontWeight: 600 }}>
        <span>{isDoc ? '📄' : '📌'}</span>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 210 }}>
          {isDoc ? (c.title || c.filename) : 'Agency fact'}
        </span>
        {isDoc && c.outdated && (
          <span data-testid="faq-outdated" title={c.newer_doc_date ? `A newer document is dated ${fmtDate(c.newer_doc_date)}` : 'A newer document exists'}
            style={{ background: '#f59e0b', color: '#1a1a1a', borderRadius: 8, padding: '1px 6px', fontSize: 10, fontWeight: 700 }}>
            Outdated{c.newer_doc_date ? ` — newer doc ${fmtDate(c.newer_doc_date)}` : ''}
          </span>
        )}
        {!isDoc && c.resolves_conflict && (
          <span style={{ background: '#0e7c86', color: '#fff', borderRadius: 8, padding: '1px 6px', fontSize: 10, fontWeight: 700 }}>Admin ruling</span>
        )}
      </span>
      <span style={{ fontSize: 11, color: sub }}>
        {isDoc ? `${fmtDate(c.doc_date)} · p. ${c.page}${c.filename && c.title !== c.filename ? ` · ${c.filename}` : ''}`
               : (c.updated_at ? `updated ${fmtDate(c.updated_at)}` : '')}
      </span>
      <span style={{ fontSize: 12, fontStyle: 'italic', lineHeight: 1.35 }}>“{c.quote}”</span>
    </button>
  );
}

export function CitationList({ citations, darkMode, onOpen }) {
  if (!citations || !citations.length) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
      {citations.map((c, i) => <CitationCard key={i} c={c} darkMode={darkMode} onOpen={onOpen} />)}
    </div>
  );
}

export function ConflictBox({ conflict, darkMode, onOpen }) {
  return (
    <div data-testid="faq-conflict" style={{ marginTop: 10, border: '1px solid #f59e0b', borderRadius: 8, padding: '8px 10px',
      background: darkMode ? '#2b2416' : '#fff8e6' }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: '#b45309' }}>⚠ Conflicting info — pending admin review</div>
      <div style={{ fontSize: 12, marginTop: 3 }}><b>{conflict.topic}</b>{conflict.summary ? ` — ${conflict.summary}` : ''}</div>
      <CitationList citations={conflict.citations} darkMode={darkMode} onOpen={onOpen} />
    </div>
  );
}
